import { Box, Button } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IB2B_Invoice } from "../type/b2bType";
import B2BMoneyReceiptForm from "./B2BMoneyReceiptForm";

interface IProps {
	handleClose: () => void;
	invoiceDetails?: IB2B_Invoice;
}
const CreateB2BMoneyReceipt = ({ handleClose, invoiceDetails }: IProps) => {
	const {
		mutate: CreateB2BMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<void, void>({
		method: "POST",
		endPoint: "/api/admin/b2b/money-receipt",
		invalidateQueries: ["b2b-single-MR", "b2b-money-receipt"],
	});
	const { control, register, handleSubmit, watch } = useForm<any>({
		defaultValues: {
			payment_date: dayjs().format("YYYY-MM-DD"),
		},
	});
	const onSubmit = (formData: any) => {
		if (invoiceDetails?.id && invoiceDetails?.b2b_id) {
			formData.b2b_id = invoiceDetails?.b2b_id;
			formData.invoice_id = invoiceDetails?.id;
		}
		CreateB2BMoneyReceipt(formData);
	};

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);

	return (
		<Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ p: 2 }}>
			<B2BMoneyReceiptForm
				register={register}
				watch={watch}
				control={control}
				invoiceDetails={invoiceDetails}
			/>

			<Button
				type='submit'
				fullWidth
				variant='contained'
				sx={{ mt: 3 }}
				disabled={isPending}
			>
				Create Money Receipt
			</Button>
		</Box>
	);
};

export default CreateB2BMoneyReceipt;
